import {NavigationExtras, Params} from '@angular/router';
import {Action} from '@ngrx/store';

import {type} from '../utilities/type';

export const routerActions = {
  GO: type('[Router] Go'),
  REPLACE: type('[Router] Replace'),
  BACK: type('[Router] Back'),
  FORWARD: type('[Router] Forward')
};
/* tslint:disable */
export class GoAction implements Action {
  readonly type = routerActions.GO;
  constructor(public payload: { path: any[]; query?: Params; extras?: NavigationExtras; }) {}
}

export class ReplaceAction implements Action {
  readonly type = routerActions.REPLACE;
  constructor(public payload: { path: any[]; query?: Params; extras?: NavigationExtras; }) {}
}

export class BackAction implements Action { readonly type = routerActions.BACK; }

export class ForwardAction implements Action { readonly type = routerActions.FORWARD; }

export function go(path: any[], query?: Params, extras?: NavigationExtras): GoAction {
  return new GoAction({ path, query, extras });
}

export function replace(path: any[], query?: Params, extras?: NavigationExtras): ReplaceAction {
  return new ReplaceAction({ path, query, extras });
}

export function back(): BackAction {
  return new BackAction();
}

export function forward(): ForwardAction {
  return new ForwardAction();
}
